"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _video = _interopRequireDefault(require("@atlaskit/icon/core/video"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const VideoFilledIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M17.37 14.954 15 13.807v-3.613l2.37-1.148c.285-.138.63.05.63.343v5.222c0 .293-.345.481-.63.343"/><rect width="8" height="6" x="6" y="9" rx="1"/></g></svg>`
}, props, {
  newIcon: _video.default
}));
VideoFilledIcon.displayName = 'VideoFilledIcon';
var _default = exports.default = VideoFilledIcon;